
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"10","height":"11","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M6.219 11v-.383c.26-.052.453-.11.578-.172a.639.639 0 00.289-.258.945.945 0 00.094-.453c0-.177-.021-.367-.063-.57a7.277 7.277 0 00-.18-.695L6.649 7.46h-3.64l-.266.766a7.69 7.69 0 00-.265.875 2.639 2.639 0 00-.063.539c0 .312.078.541.234.687.162.146.407.242.735.29V11H.047v-.383c.292-.047.544-.216.758-.508.218-.291.43-.708.632-1.25L4.696.211H5.93l2.656 8.71c.125.407.234.717.328.93.099.214.216.38.352.5.135.12.32.209.554.266V11H6.22zm-3-4.219h3.265L5 1.742l-1.781 5.04z","fill":"currentColor"}})])
          )
        }
      }
    